module.exports = __webpack_public_path__ + "img/solar-panel.97000dc8.svg";